import CheckCircleRoundedIcon from '@material-ui/icons/CheckCircleRounded';
import HistoryRoundedIcon from '@material-ui/icons/HistoryRounded';
import RadioButtonUncheckedRoundedIcon from '@material-ui/icons/RadioButtonUncheckedRounded';
import { TASK_STATUS } from 'features/daily-plan/constants';

export const TASK_ICON_MAP = {
  [TASK_STATUS.completed.id]: CheckCircleRoundedIcon,
  [TASK_STATUS.pending.id]: RadioButtonUncheckedRoundedIcon,
  [TASK_STATUS.overdue.id]: HistoryRoundedIcon
};
